import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ContractApiService {
  constructor(private api: ApiService) {}

  // GET API

  getContractList(payload: any) {
    return this.api.get(`/contracts?office_id=${this.api.getOfficeId()}`, payload);
  }
  getContractStatusList() {
    return this.api.get(`/contracts/get-contract-tags?office_id=${this.api.getOfficeId()}`);
  }
  getContractById(contract_id: any) {
    return this.api.get(`/contracts/${contract_id}`);
  }
  getContractByPropertyId(propertyId: any) {
    return this.api.get(`/contracts/get-by-project-property?office_id=${this.api.getOfficeId()}&listingid=${propertyId}`);
  }

  // POST API
  createContract(payload: any) {
    return this.api.post('/contracts', payload);
  }
  contractPresentOffer(payload: any) {
    return this.api.post('/contracts/present-offer', payload);
  }

  // PUT API
  updateContract(contract_id: any, payload: any) {
    return this.api.put('/contracts/' + contract_id, payload);
  }
  updateEOI(eoi_id: any, payload: any) {
    return this.api.put('/expression-of-interest/' + eoi_id, payload);
  }
  updateContractStatusById(contractId: string[], status: string) {
    return this.api.put('/contracts/update-contract-status', {
      contracts: contractId,
      status: status,
    });
  }

  // DELETE API

  deleteContract(contract_id: any) {
    return this.api.delete(`/contracts/${contract_id}`);
  }
  deleteMultipleContract(payload: any) {
    let contract_id = {
      contractIds: payload,
    };
    return this.api.delete(`/contracts-bulk-delete`, contract_id);
  }

  deleteEOI(contract_id: any) {
    return this.api.delete(`/expression-of-interest/${contract_id}/${this.api.getOfficeId()}`);
  }
  deleteMultipleEOI = (payload: any) => {
    let eoi_id = {
      office_id: this.api.getOfficeId(),
      selected: payload,
    };
    return this.api.delete('/expression-of-interest-bulk-delete', eoi_id);
  };
}
